import { render, staticRenderFns } from "./SpendingForm.vue?vue&type=template&id=0fbe7aa5&"
import script from "./SpendingForm.vue?vue&type=script&lang=js&"
export * from "./SpendingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports